module.exports = __webpack_public_path__ + "img/19_48.1fb6228b.png";